<template>
  <CustomModal v-if="open" @close="$emit('close')">
    <template v-slot:body>
      <div class="grid items-center grid-cols-1 row-gap-8" style="width: 300px;">
        <div class="text-xl font-bold text-text leading-tight mr-10">{{ $t('createGroupTitle') }}</div>
        <BaseInput v-model.trim="$v.expense_group_title.$model"
                   :label="$t('createInputLabel')"
                   class="col-span-2"
                   :class="{'--error':$v.expense_group_title.$error }">
          <template v-slot:errors="">
            <div class="error" v-if="!$v.expense_group_title.required">{{ $t('errors.required') }}</div>
          </template>
        </BaseInput>
        <BaseButton theme="red"
                    :loading="submitted"
                    @click="createGroup">
          {{ $t('createGroupBtn') }}
        </BaseButton>
      </div>
    </template>
  </CustomModal>
</template>

<script>
import {mapActions, mapState} from "vuex";
import CustomModal from "@/components/UI/modals/CustomModal";
import BaseInput from "@/components/UI/BaseInput/BaseInput";
import BaseButton from "@/components/UI/BaseButton";
import {required} from "vuelidate/lib/validators";

export default {
  name: "AddExpenseGroupModal",
  components: {
    BaseButton,
    BaseInput,
    CustomModal,
  },
  props: {
    open: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      expense_group_title: '',
      submitted: false
    }
  },
  validations: {
    expense_group_title: {
      required
    }
  },
  computed: {
    ...mapState('space', ['current_space']),
    ...mapState('space/expenses', ['expense_groups']),
  },
  methods: {
    ...mapActions('space/expenses', ['getExpenseGroups', 'createExpenseGroup']),
    createGroup() {
      this.submitted = true;
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let group_data = {
              space_id: this.current_space.data.id,
              title: this.expense_group_title,
              order: this.expense_groups.data.length
            }
        ;
        this.createExpenseGroup(group_data).then(res => {
          if (res.body.success) {
            this.getExpenseGroups();
            this.$emit('created', res.body.data);
            this.expense_group_title = '';
            this.$toasted.success('Группа расходов создана')
          } else {
            console.log(res)
          }
        }).catch(err => {
          console.log(err)
        }).finally(() => {
          this.submitted = false;
        });
      } else {
        this.$toasted.error('Проверьте поля')
        this.submitted = false;
      }
    }
  },
  i18n: {
    messages: {
      en: {
        createGroupTitle: 'Create group for expense',
        createInputLabel: 'Name your group',
        createGroupBtn: 'Create',
      },
      ru: {
        createGroupTitle: 'Создать группу для расходов',
        createInputLabel: 'Название группы',
        createGroupBtn: 'Создать',
      }
    }
  }
}
</script>
